import StoreSettings from './StoreSettings'
export default StoreSettings
